<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="8" >
            <a-form-item label="支付时间">
              <a-range-picker
                v-model="searchObj.createTimeRange"
                format="YYYY-MM-DD HH:mm:ss"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],
                }"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
                @ok="onDateOk"
              />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item label="订单号">
              <a-input
                placeholder="请输入订单号"
                v-model="searchObj.id"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item label="订单状态">
              <a-select
                placeholder="请选择订单状态"
                v-model="searchObj.status"
              >
                <a-select-option
                  v-for="item in orderStatusOptions"
                  :key="item.value"
                  :value="item.value"
                >{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="姓名">
              <a-input
                placeholder="请输入姓名"
                v-model="searchObj.memberName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="手机号">
              <a-input
                placeholder="请输入手机号"
                v-model="searchObj.mobileNumber"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="unionid">
              <a-input
                placeholder="请输入unionid"
                v-model="searchObj.unionid"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="商品名称">
              <a-input
                placeholder="请输入商品名称"
                v-model="searchObj.goodsName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="支付方式">
              <a-select
                style="width: 155px"
                placeholder="请选择支付方式"
                v-model="searchObj.paymentType"
              >
                <a-select-option
                  v-for="item in payTypeOptions"
                  :key="item.value"
                  :value="item.value"
                >{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :sm="6">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
              >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
              >重置</a-button
              >
              <!--展开按钮，控制toggleSearchStatus状态-->
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button
        type="primary"
        icon="download"
        @click="handleExportXls('exportXlsUrl','会员订单记录')"
      >全部导出</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-dropdown >
          <a-menu slot="overlay">
            <a-menu-item key="2" @click="handleExportXls('exportXlids','会员订单记录')"><a-icon type="download"/>选择导出</a-menu-item>
          </a-menu>
          <a-button> 批量 <a-icon type="down" /></a-button>
        </a-dropdown>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
        </span>

      </a-table>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import { getAction, postAction, downFile } from '@/api/manage';
  import {
    initDictOptions,
  } from '@/components/dict/JDictSelectUtil';
  import moment from 'moment';
  const columns = [
    {
      title:'订单号',
      align:"center",
      dataIndex: 'id'
    },
    // {
    //   title:'交易单号',
    //   align:"center",
    //   dataIndex: 'goodsId'
    // },
    {
      title:'下单时间',
      align:"center",
      dataIndex: 'paymentTime'
    },
    {
      title:'姓名',
      align:"center",
      dataIndex: 'memberName'
    },
    {
      title:'商品名称',
      align:"center",
      dataIndex: 'goodsName'
    },
    {
      title:'支付金额',
      align:"center",
      dataIndex: 'payment',
      customRender: text => {
        if (text >= 0) {
          return text+'元';
        } else {
          return "--";
        }
      },
    },
    {
      title:'支付方式',
      align:"center",
      dataIndex: 'paymentType_dictText',
    },
    {
      title:'订单状态',
      align:"center",
      dataIndex: 'status_dictText'
    },
    {
      title:'支付时间',
      align:"center",
      dataIndex: 'paymentEndTime',
      customRender: text => {
        return text || "--";
      },
    }
  ];
  export default {
    name: 'PmOmOrderList',
    components: {
    },
    data () {
      return {
        description: '订单记录管理页面',
        //--------列表页重复代码 start-------------
        searchObj: {
          id: "",
          status:"",
          memberName:"",
          mobileNumber:"",
          unionid:"",
          goodsName:"",
          paymentType:"",
          createTimeRange:[]
        },
        /* 查询折叠 */
        toggleSearchStatus: false,
        /* table选中keys*/
        selectedRowKeys: [],
        loading: false,
        dataSource: [],
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条';
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        //--------列表页重复代码 end-------------
        orderStatusOptions:[],
        payTypeOptions:[],
        // 表头
        columns,
        url: {
          list: process.env.VUE_APP_CMS_CUSTOMER + "/pmom/pmOmOrder/list",
          deleteBatch: process.env.VUE_APP_CMS_CUSTOMER + "/pmom/pmOmOrder/deleteBatch",
          exportXlsUrl: process.env.VUE_APP_CMS_CUSTOMER + "/pmom/pmOmOrder/exportXls",
          exportXlids: process.env.VUE_APP_CMS_CUSTOMER + "/pmom/pmOmOrder/exportXlids"

        }
      }
    },
    created() {
      this.loadData(1);
      this.initDictConfig();
    },
    methods: {
      moment,
      onDateChange: function(value, dateString) {
        console.log(dateString[0], dateString[1]);
        this.searchObj.payStartTime = dateString[0];
        this.searchObj.payEndTime = dateString[1];
      },
      onDateOk(value) {
        console.log(value);
      },
      initDictConfig() {
        console.log('--我才是真的方法!--');
        //初始化字典
        initDictOptions('order_status').then((res) => {
          if (res.success) {
            this.orderStatusOptions = res.result;
          }
        });
        initDictOptions('pay_type').then((res) => {
          if (res.success) {
            this.payTypeOptions = res.result;
          }
        });
      },
      //-----------------列表页重复代码-开始--------------
      handleToggleSearch() {
        this.toggleSearchStatus = !this.toggleSearchStatus;
      },
      handleExportXls(exportXlsUrlName,fileName) {
        if (!fileName || typeof fileName != 'string') {
          fileName = '导出文件';
        }
        let param = { ...this.searchObj };
        let idParam = ""
        if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          param['ids'] = this.selectedRowKeys.join(',');
          idParam = `?ids=${param.ids}`;
        }
        console.log('导出参数', param);
        downFile(this.url[exportXlsUrlName] + idParam, param).then(data => {
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        });
      },
      //分页
      handleTableChange(pagination, filters, sorter) {
        this.onClearSelected(); //分页切换时清空表格选中
        //分页、排序、筛选变化时触发
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
        }
        this.ipagination = pagination;
        this.loadData();
      },
      loadData(arg) {
        let that = this;
        if (arg === 1) {
          that.ipagination.current = 1;
        }
        let params = this.getQueryParams();
        getAction(this.url.list,params).then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource =
              res.result && res.result.records ? res.result.records : [];
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      },
      getQueryParams() {
        let param = Object.assign(
          this.searchObj
        );

        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getQueryField() {
        let str = 'id,';
        this.columns.forEach(function(value) {
          str += ',' + value.dataIndex;
        });
        return str;
      },
      handleAdd: function(course) {
        console.log(course);
        if (course) {
          if (course.type == 'click') {
            course = undefined;
          }
        }

        this.$refs.modalForm.add(course);
        this.$refs.modalForm.title = '新增';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleEdit: function(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = '编辑';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleDelete: function(id) {
        if (!this.url.delete) {
          this.$message.error('请设置url.delete属性!');
          return;
        }
        let that = this;
        postAction(that.url.delete, { id: id }).then(res => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      modalFormOk() {
        // 新增/修改 成功时，重载列表
        this.loadData();
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        console.log(this.name);
        if (this.name == 'courseManageModal') {
          let courseList = selectedRowKeys;
          this.form.setFieldsValue({
            courseList
          });
        }
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
      },
      searchQuery() {
        this.loadData(1);
      },
      //重置
      searchReset() {
        this.searchObj = {};
        this.loadData(1);
      }
      //-----------------列表页重复代码-结束--------------

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>